// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1LNeh","tab":"Tabs_tab__3B7pE","tabActive":"Tabs_tabActive__3f3fV"};